<div class="dashboard-wrap">
    <div class="sidenav-wrap">
        <app-side-menu sideMenuType="type2"></app-side-menu>
    </div>
    <div class="page-wrap">
        <div class="loader-wrap">
            <div class="loder-item" *ngIf="showSnapLoading" style="top: -10px;">
                <div class="shimmertext">
                    <span class="loader"></span>
                </div>
            </div>
            <div class="title-action-wrap">
                <app-main-heading title="Snapshot" customStyle="title"></app-main-heading>
                <div class="action-wrap">
                    <button type="button" class="btn btnTheme blue" [ngClass]="{'btn-notify': snapFilterCount > 0}" (click)="openSnapFilterModal()">
                        Filter By <img src="./assets/images/down-arrow.svg" class="btn-icon btn-right-icon" alt="down-arrow"/>
                    </button>
                </div>
            </div>
            <section class="app-sec">
                <div class="row">
                    <div class="col-12 col-lg-8">
                        <div class="row row-xy-12">
                            <div class="col-6 col-lg-3">
                                <div class="card-wrap card-shadow card-showcase card-showcase-half-height justify-align-item-center">
                                    <div class="text-wrap">
                                        <p class="subtitle2 grey-color">Completed Registrations</p>
                                        <p class="body1 font-700 font-circular-std text-color">{{consvertNumber(this.snapshotData?.complete_registration)}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-lg-3">
                                <div class="card-wrap card-shadow card-showcase card-showcase-half-height justify-align-item-center">
                                    <div class="text-wrap">
                                        <p class="subtitle2 grey-color">Indrafts</p>
                                        <p class="body1 font-700 font-circular-std text-color">{{consvertNumber(this.snapshotData?.DRAFT_registration)}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-lg-3">
                                <div class="card-wrap card-shadow card-showcase card-showcase-half-height justify-align-item-center">
                                    <div class="text-wrap">
                                        <p class="subtitle2 grey-color">Rejected Entries</p>
                                        <p class="body1 font-700 font-circular-std text-color">{{consvertNumber(this.snapshotData?.rejected_entries)}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-lg-3">
                                <div class="card-wrap card-shadow card-showcase card-showcase-half-height justify-align-item-center">
                                    <div class="text-wrap">
                                        <p class="subtitle2 grey-color">Shortlisted Entries</p>
                                        <p class="body1 font-700 font-circular-std text-color">{{consvertNumber(this.snapshotData?.shortlisted_entries)}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-lg-3">
                                <div class="card-wrap card-shadow card-showcase card-showcase-half-height justify-align-item-center">
                                    <div class="text-wrap">
                                        <p class="subtitle2 grey-color">Web Registration</p>
                                        <p class="body1 font-700 font-circular-std text-color">{{consvertNumber(this.snapshotData?.web_registration)}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-lg-3">
                                <div class="card-wrap card-shadow card-showcase card-showcase-half-height justify-align-item-center">
                                    <div class="text-wrap">
                                        <p class="subtitle2 grey-color">WhatsApp Registration</p>
                                        <p class="body1 font-700 font-circular-std text-color">{{consvertNumber(this.snapshotData?.whatsapp_registration)}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-lg-3">
                                <div class="card-wrap card-shadow card-showcase card-showcase-half-height justify-align-item-center">
                                    <div class="text-wrap">
                                        <p class="subtitle2 grey-color">IVR Registration</p>
                                        <p class="body1 font-700 font-circular-std text-color">{{consvertNumber(this.snapshotData?.IVR_registration)}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 col-lg-3">
                                <div class="card-wrap card-shadow card-showcase card-showcase-half-height justify-align-item-center">
                                    <div class="text-wrap">
                                        <p class="subtitle2 grey-color">Archived Entries</p>
                                        <p class="body1 font-700 font-circular-std text-color">{{consvertNumber(this.snapshotData?.archived_entries)}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4 mt-lg-0 mt-4" *ngIf="uiPrivileges.displayAllLanguages">
                        <div class="card-wrap card-shadow card-showcase card-showcase-height">
                            <div class="table-wrap table-overflow showcase-table-wrap">
                                <table mat-table [dataSource]="languageSnapData">
                                    <ng-container matColumnDef="language">
                                        <th mat-header-cell *matHeaderCellDef class="blue-color"> Language </th>
                                        <td mat-cell *matCellDef="let element" class="text-capitalize"> {{element.language}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="total">
                                        <th mat-header-cell *matHeaderCellDef class="text-color"> Total </th>
                                        <td mat-cell *matCellDef="let element"> {{consvertNumber(element.total)}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="completed">
                                        <th mat-header-cell *matHeaderCellDef class="text-color"> Completed </th>
                                        <td mat-cell *matCellDef="let element"> {{consvertNumber(element.completed)}} </td>
                                    </ng-container>

                                    <tr class="mat-row" *matNoDataRow>
                                        <td class="mat-cell" colspan="3">
                                            <div class="text-wrap p-3">
                                                <p class="subtitle1 black-color">No result found</p>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr mat-header-row *matHeaderRowDef="languageSnapColumn; sticky: true"></tr>
                                    <tr mat-row *matRowDef="let row; columns: languageSnapColumn;"></tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4 mt-lg-0 mt-4" *ngIf="!uiPrivileges.displayAllLanguages">
                        <div class="card-wrap card-shadow card-showcase card-showcase-height" *ngIf="languageSnapData">
                            <div class="text-wrap">
                                <p class="body1 grey-color text-start mb-4 mt-1">{{languageSnapData[0]?.language}}</p>
                                <h1 class="font-700 font-circular-std text-color mb-4 text-start text-capitalize">{{consvertNumber(languageSnapData[0]?.Total)}}</h1>
                                <p class="subtitle1 mb-2 text-start d-flex justify-content-between mb-3">
                                    <span class="grey-color">Draft</span>
                                    <span class="font-700 text-color font-circular-std">{{consvertNumber(languageSnapData[0]?.draft)}}</span>
                                </p>
                                <p class="subtitle1 mb-2 text-start d-flex justify-content-between">
                                    <span class="grey-color subtitle1">Completed</span>
                                    <span class="font-700 text-color subtitle1 font-circular-std">{{consvertNumber(languageSnapData[0]?.completed)}}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="loader-wrap">
            <section class="app-sec">
                <div class="row">
                    <div class="col-12">
                        <div class="overlay-wrap" [ngClass]="{'active': isExpandView}"></div>
                        <div class="card-wrap registartion-list-wrap" [ngClass]="{'expand-view': isExpandView}">
                            <div class="card-header-wrap card-header-action">
                                <div class="text-wrap">
                                    <h3 class="font-circular-std font-500 text-color">Registration Listing</h3>
                                </div>
                                <div class="action-wrap">
                                    <button type="button" class="search-wrap btn btnThemeOutline blue me-2" [ngClass]="{'active': isSearchActive}">
                                        <div class="input-wrap">
                                            <input type="text" placeholder="Search..." (input)="searchInput($event)" (blur)="searchLeave($event)"/>
                                        </div>
                                        <img src="./assets/images/search-blue.svg" class="btn-icon" alt="search-blue" (click)="searchClick()"/>
                                    </button>
                                    <button type="button" class="btn btnThemeOutline blue me-2" [ngClass]="{'btn-notify': registrationFilterCount > 0}" (click)="openRegistrationFilterModal()">
                                        <img src="./assets/images/filter.svg" class="btn-icon btn-left-icon" alt="filter"/> Filter By
                                    </button>
                                    <button type="button" class="btn btnIcon" (click)="expandView()">
                                        <img [src]="!isExpandView ? './assets/images/arrows-expand.svg' : './assets/images/arrows-expand-in.svg'" class="btn-icon" alt="arrows-expand"/>
                                    </button>
                                </div>
                            </div>
                            <div class="card-edge-wrap">
                                <div class="loder-item"  *ngIf="showRegistrationLoading">
                                    <div class="shimmertext">
                                        <span class="loader"></span>
                                    </div>
                                </div>
                                <div class="table-wrap table-overflow table-listing-data registration-table-wrap">
                                    <table mat-table [dataSource]="registrationListData">
                                        <ng-container matColumnDef="reg_id">
                                            <th mat-header-cell *matHeaderCellDef> Registration  ID </th>
                                            <td mat-cell *matCellDef="let element"> {{element.reg_id}} </td>
                                        </ng-container>
                                        <ng-container matColumnDef="contact_number">
                                            <th mat-header-cell *matHeaderCellDef> Mobile Number </th>
                                            <td mat-cell *matCellDef="let element">
                                                <span>{{element.contact_number}}</span>
                                                <div class="tag-wrap">
                                                    <span class="tag tag-small blue me-2" *ngIf="element.status != '-'">{{element.status}}</span>
                                                    <span class="tag tag-small red" *ngIf="element.user_cat != '-'">{{element.user_cat}}</span>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="name" *ngIf="uiPrivileges.nameInContestListing">
                                            <th mat-header-cell *matHeaderCellDef> Name </th>
                                            <td mat-cell *matCellDef="let element" class="text-capitalize"> {{element.name}} </td>
                                        </ng-container>
                                        <ng-container matColumnDef="source">
                                            <th mat-header-cell *matHeaderCellDef> Source </th>
                                            <td mat-cell *matCellDef="let element">
                                                <span>{{element.source}}</span>
                                                <div class="tag-wrap source-tag">
                                                    <span class="tag tag-small tag-outline font-500 blue me-2 text-uppercase" *ngIf="element.language != '-'">{{element.language}}</span>
                                                    <span class="tag tag-small tag-outline font-500 blue me-2" *ngIf="element.answer_type.includes('VOICE') && element.answer_type != '-'">
                                                        <img src="./assets/images/mic.svg" alt="mic"/>
                                                    </span>
                                                    <span class="tag tag-small tag-outline font-500 me-2 px-0" *ngIf="element.answer_type.includes('IMAGE') && element.answer_type != '-'">
                                                        <img src="./assets/images/file-image.svg" alt="file-image"/>
                                                    </span>
                                                    <span class="tag tag-small tag-outline font-500 blue me-2" *ngIf="element.answer_type.includes('TEXT') && element.answer_type != '-'">TXT</span>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="validation_status">
                                            <th mat-header-cell *matHeaderCellDef> Validation Status </th>
                                            <td mat-cell *matCellDef="let element"> {{element.validation_status}} </td>
                                        </ng-container>
                                        <ng-container matColumnDef="submitted_dt">
                                            <th mat-header-cell *matHeaderCellDef> Submitted Date </th>
                                            <td mat-cell *matCellDef="let element" class="text-nowrap"> {{convertDate(element.submitted_dt)}} </td>
                                        </ng-container>
                                        <ng-container matColumnDef="action">
                                            <th mat-header-cell *matHeaderCellDef> Action </th>
                                            <td mat-cell *matCellDef="let element">
                                                <div class="btn-wrap">
                                                    <button type="button" class="btn btnIcon" [routerLink]="['/validate-dash-details/', element?.id ,1]" *ngIf="element?.isEditEnabled">
                                                        <img src="./assets/images/pencil-alt.svg" class="btn-icon" alt="pencil-alt"/>
                                                    </button>
                                                    <button type="button" class="btn btnIcon" [routerLink]="['/validate-dash-details/', element?.id ,0]">
                                                        <img src="./assets/images/eye.svg" class="btn-icon" alt="eye"/>
                                                    </button>
                                                </div>
                                            </td>
                                        </ng-container>

                                        <tr class="mat-row" *matNoDataRow>
                                            <td class="mat-cell" colspan="3">
                                                <div class="text-wrap p-3">
                                                    <p class="subtitle1 black-color">No result found</p>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr mat-header-row *matHeaderRowDef="registrationListColumn; sticky: true"></tr>
                                        <tr mat-row *matRowDef="let row; columns: registrationListColumn;"></tr>
                                    </table>
                                </div>
                            </div>
                            <div class="card-edge-wrap card-footer-wrap" *ngIf="totalRecords > 0">
                                <div class="pagination-wrap">
                                    <app-pagination class="mt-4 d-block"
                                        paginationType="type2"
                                        [currentPage]="currentPage"
                                        [totalItems]="totalRecords"
                                        [itemsPerPage]="pageLimit"
                                        (pageChange)="onPageChange($event)"
                                        (pageSizeChange)="onPageSizeChange($event)">
                                    </app-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>


<ng-template #showEmptyView>
    <tr *ngIf="!loading">
      <td colspan="9">
        <div class="nftd text-center p-4 d-block w-100">No Product found..</div>
      </td>
    </tr>
</ng-template>

<!-- <app-be-a-part [becomeASellerNowScreenData]="titleText" [becomeASellerNowButtonScreenData]="BtnText"></app-be-a-part> -->
